// extracted by mini-css-extract-plugin
export var button = "_ns-1";
export var container = "_ns-0";